var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppBurgerMenu',{staticClass:"card-modal__mobile-menu",scopedSlots:_vm._u([{key:"menu-content",fn:function(){return [_c('CardModalSidebarLinks',{attrs:{"drive-folder":_vm.card.drive_folder}}),_c('CardModalSidebarActions',{attrs:{"card":_vm.card}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }